import {
  actions,
  getAllDailyBooksAsync,
  addNewDailyContentToSpicificDateAsync,
  addNewDailyContentToTheEndAsync,
} from "./slices";

export const DailyContentActions = {
  ...actions,
  getAllDailyBooksAsync,
  addNewDailyContentToSpicificDateAsync,
  addNewDailyContentToTheEndAsync,
};
